/**
 * Regista eventos do funil de checkout (MY) em MongoDB via
 * /api/analytics/checkout-event. Fire-and-forget, silencioso.
 * Passos: checkout | payment | blocked | error | completed.
 */
export function trackCheckout(step, extra = {}) {
  try {
    const KEY = "my_checkout_session";
    let sid = window.sessionStorage.getItem(KEY);
    if (!sid) {
      sid = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `s-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.sessionStorage.setItem(KEY, sid);
    }
    const API = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${API}/api/analytics/checkout-event`, {
      method: "POST",
      credentials: "include",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sid, step, ...extra }),
    }).catch(() => {});
  } catch (e) { /* noop */ }
}

/**
 * Constrói um snapshot compacto do carrinho para anexar aos eventos
 * `checkout`/`payment` — permite ver, no painel Admin, o conteúdo dos
 * carrinhos que não se concretizaram.
 */
export function cartSnapshot(produtos = [], packs = []) {
  const items = [
    ...(produtos || []).map((p) => ({
      nome: p.Descricao || "Produto",
      qtd: Number(p.Quantidade) || 1,
      preco: Number(p.preco ?? p.PrecoUnitario) || 0,
    })),
    ...(packs || []).map((p) => ({
      nome: p.Descricao || "Pack",
      qtd: Number(p.Quantidade) || 1,
      preco: Number(p.preco ?? p.PrecoUnitario) || 0,
    })),
  ];
  const total = items.reduce((s, it) => s + it.preco * it.qtd, 0);
  return { cart: items, total: Math.round(total * 100) / 100 };
}
